import React from 'react';
import './PageLoadingFallback.css';

export default function PageLoadingFallback() {
  return (
    <div className="ay-page-loading-root" role="status" aria-label="Loading page content">
      <div className="ay-loading-pulse-container">
        <div className="ay-loading-spinner-ring" />
        <div className="ay-loading-logo-box">
          <img
            src="/assets/images/andhra-yatri-logo.png"
            alt="Andhra Yatri"
            className="ay-loading-logo-img"
            onError={(e) => {
              // Graceful fallback if image is not yet cached
              e.currentTarget.style.display = 'none';
            }}
          />
        </div>
      </div>
      <div className="ay-loading-text-glow">
        <span>Loading Andhra Yatri</span>
        <div className="ay-loading-dots">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
}
